<template>
  <div class="business-small-card-wrapper">
    <BusinessSmallCard
      image="https://placehold.co/150x150"
      title="Java Brew Café"
      description="Seattle, WA"
    />
  </div>
</template>
    
    <script>
    import BusinessSmallCard from '@/components/calico/businessSmallCard/index.vue';
    
    export default {
      name: 'BusinessSmallCardPageView',
      components: {
          BusinessSmallCard
      }
    };
    </script>
  
    <style lang="scss" scoped>
      .business-small-card-wrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: $space-large
      }
  </style>